import { render } from "./AppPagination.vue?vue&type=template&id=edaeb424&ts=true"
import script from "./AppPagination.vue?vue&type=script&lang=ts"
export * from "./AppPagination.vue?vue&type=script&lang=ts"

import "./AppPagination.vue?vue&type=style&index=0&id=edaeb424&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__